import { PropsWithChildren } from "react";
import { ToastContainer } from "react-toastify";
import { useInAppNotifications } from "@/hooks/inAppNotifications/useInAppNotifications";
import useIsTouchDevice from "@/hooks/misc/useIsTouchDevice";

export const InAppNotificationsContainer = ({
  children,
}: PropsWithChildren) => {
  useInAppNotifications();
  const isTouchDevice = useIsTouchDevice();

  return (
    <>
      {children}
      <ToastContainer stacked={!isTouchDevice} autoClose={false} />
    </>
  );
};
